import React from "react";
import { PlusCircle, Sparkles, ArrowUpRight } from "lucide-react";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";

interface DepositCardProps {
  onClick: () => void;
}

const DepositCard: React.FC<DepositCardProps> = ({ onClick }) => {
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();

  const isDark = theme === "dark";

  return (
    <div className="px-1 mb-2">
      <button
        onClick={onClick}
        className={`w-full relative overflow-hidden rounded-3xl p-6 transition-all active:scale-[0.98] group shadow-xl ${
          isDark
            ? "bg-gradient-to-br from-indigo-900 via-indigo-950 to-purple-900 border border-indigo-500/30 shadow-indigo-500/10"
            : "bg-gradient-to-br from-indigo-600 via-indigo-700 to-purple-600 text-white shadow-indigo-600/30"
        }`}
      >
        {/* Decorative Background Elements */}
        <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:scale-110 transition-transform duration-700 ease-out">
          <PlusCircle size={140} strokeWidth={1} />
        </div>
        <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-white/5 rounded-full blur-3xl" />
        <div className="absolute top-0 right-0 w-32 h-32 bg-purple-400/10 rounded-full blur-3xl animate-pulse" />

        <div className="flex items-center justify-between relative z-10">
          <div className="flex items-center gap-5">
            <div className={`flex items-center justify-center w-16 h-16 rounded-2xl shadow-inner border transition-transform duration-500 group-hover:rotate-12 ${
              isDark 
                ? "bg-indigo-500/20 border-indigo-400/20 shadow-black/20" 
                : "bg-white/20 border-white/40 shadow-indigo-800/20"
            }`}>
              <PlusCircle size={36} className={isDark ? "text-indigo-400" : "text-white"} />
            </div>
            
            <div className="text-left">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="font-extrabold text-2xl tracking-tight uppercase italic">
                  {getTranslationText("deposit")}
                </h3>
                <Sparkles size={18} className={isDark ? "text-indigo-300" : "text-indigo-100"} fill="currentColor" />
              </div>
              <p className={`text-sm font-semibold tracking-wide ${isDark ? "text-indigo-300/80" : "text-indigo-100"}`}>
                GET MORE ATH INSTANTLY 🚀
              </p>
            </div>
          </div>

          <div className={`w-10 h-10 flex items-center justify-center rounded-full border transition-all duration-300 group-hover:bg-white/10 group-hover:scale-110 ${
            isDark ? "border-indigo-500/30 text-indigo-400" : "border-white/40 text-white"
          }`}>
            <ArrowUpRight size={24} />
          </div>
        </div>
        
        {/* Shine/Shimmer Effect */}
        <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out" />
      </button>
    </div>
  );
};

export default DepositCard;
